import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { captureAttribution, maybeShowAttributionDebug } from './utils/attribution';
import { initXPixel } from './utils/xpixel';

// Capture marketing attribution (UTM source) on first landing, before render.
captureAttribution();
// Visible green/red confirmation bar when the URL carries &ag_debug=1 — lets
// the live UTM test be verified without opening DevTools.
maybeShowAttributionDebug();
// X (Twitter) Ads pixel — fires PageView for conversion tracking + retargeting.
// No-op unless REACT_APP_X_PIXEL_ID is set at build time.
initXPixel();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register service worker for PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  });
}

